import { observer } from 'mobx-react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { Paper, PaperBorderType } from '@roc/ui';
import { useLoanFlags } from '../hooks/useLoanFlags';
import { Grid, Box } from '@material-ui/core';
import {
  DocumentForms,
  useDocumentStore,
} from '@roc/feature-documents';
import { useLoanStore } from '@roc/feature-loans';
import { LoanProcess } from '@roc/feature-utils';
import { useEffect, useState } from 'react';
import { TodoTaskCard } from '../components/cards/todoTaskCard';
import { LoanDetailsPaper } from '../components/loanDetailsPaper';
import { LoanKeyInformationCard } from '../components/cards/loanKeyInformationCard';
import { ResendInsuranceQuote } from 'libs/feature-documents/src/documents/components/overview/components/resendInsuranceQuote/resendInsuranceQuote';
import { RequestElmsureQuote } from 'libs/feature-documents/src/documents/components/overview/components/requestElmsureQuote/requestElmsureQuote';
import {
  ClosingStatusStepper,
} from '../components/loanDetailsStepper';
import { useLoanRoutes } from '@roc/feature-loans-routes-config';
import { useHistory } from 'react-router';

const useStyles = makeStyles((theme: Theme) => ({
  paper: {
    border: '1px solid #d5d5d5 !important',
    borderRadius: 16,
    overflow: 'hidden',
  },
}));

export const ClosingTasksTab = observer(() => {
  const { loanStore } = useLoanStore();
  const { documentStore } = useDocumentStore();
  const { loanDetails } = loanStore;
  const { loanTodosStore } = documentStore;
  const { showResendInsuranceButton } = useLoanFlags();
  const currentForm = documentStore.documentFormStore.currentForm;
  const loanId = loanDetails?.loanId;
  const classes = useStyles();
  const { loanRoutesConfig } = useLoanRoutes();
  const { push } = useHistory();
  const { showUnderwritingAndClosingTab } = useLoanFlags();
  const loanProcess = LoanProcess.CLOSING;
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    if (showUnderwritingAndClosingTab) {
      push(loanRoutesConfig.loans(loanId).children.todos.url);
    }
    loanTodosStore.setShowOnlyPending(false);
    loanTodosStore.setPrioritiesFilter([]);
    setInitialized(true);
  }, []);

  const todos =
    documentStore.loanTodosStore.todosByLoanProcess[loanProcess] ?? [];

  useEffect(() => {
    if (!currentForm && todos.length > 0) {
      loanTodosStore.fetchTodos(loanId, loanProcess);
    }
  }, [loanId, currentForm]);

  const ccTodos = loanTodosStore.closingConditionsTodos ?? [];

  return (
    <>
      <Grid item xs={12}>
        <Paper borderType={PaperBorderType.SOLID_BORDER} className={classes.paper}>
          <ClosingStatusStepper />
        </Paper>
      </Grid>
      {showResendInsuranceButton && (
        <Grid item xs={12}>
          <LoanDetailsPaper>
            <Box display="flex" justifyContent="flex-end" p={2}>
              <Box ml={2}>
                <ResendInsuranceQuote loanStore={loanStore} />
              </Box>
              <Box ml={2}>
                <RequestElmsureQuote loanStore={loanStore} />
              </Box>
            </Box>
          </LoanDetailsPaper>
        </Grid>
      )}
      <Grid item xs={12}>
        <LoanKeyInformationCard loanStore={loanStore} />
      </Grid>
      <Grid item xs={12}>
        {initialized && <TodoTaskCard
          showFilter
          showSectionActions={true}
          showFileName={true}
          showDownloadAll
          todos={todos}
          ccTodos={ccTodos}
          loanProcess={loanProcess}
          showActions={true}
          loanId={loanId}
        />
        }
        <DocumentForms loanId={loanId?.toString()} />
      </Grid>
    </>
  );
});
